import { State } from './selector';
import { areObjectsDeeplyEqual } from '../../util/validator';

/**
 * Helper function to help determine which part of the UI
 * needs to be updated based on state changes
 * @param {State} state New state
 * @param {State} oldState Old state
 * @returns {Object} Object containing booleans
 */
export const getUpdateFlags = (state: State, oldState: State) => {
    const { isLoggedIn, router, isContentEnabled } = state;
    const hasLoginStatusChanged = isLoggedIn !== oldState.isLoggedIn;
    const hasRouterChanged = !areObjectsDeeplyEqual(router!, oldState.router!);
    const hasContentEnabledChanged = isContentEnabled !== oldState.isContentEnabled;
    return {
        offerSummaryCard: hasRouterChanged || hasLoginStatusChanged || hasContentEnabledChanged,
    };
};
